/*
 * @Author: 李才人
 * @Date: 2021-07-29 16:42:12
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-09 17:50:18
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\config\questionnaire.ts
 * @Description:
 */
export var IQuestionComonentType;
(function (IQuestionComonentType) {
  IQuestionComonentType[IQuestionComonentType["Question"] = 0] = "Question";
  IQuestionComonentType[IQuestionComonentType["Decoration"] = 1] = "Decoration";
})(IQuestionComonentType || (IQuestionComonentType = {}));
export var DecorationType;
(function (DecorationType) {
  DecorationType[DecorationType["picture"] = 5] = "picture";
  DecorationType[DecorationType["text"] = 8] = "text";
  DecorationType[DecorationType["empty"] = -1] = "empty";
  DecorationType[DecorationType["cutOffLine"] = 15] = "cutOffLine";
  DecorationType[DecorationType["pageGap"] = 16] = "pageGap";
  DecorationType[DecorationType["calculator"] = 24] = "calculator";
})(DecorationType || (DecorationType = {}));
export var QuestionType;
(function (QuestionType) {
  QuestionType[QuestionType["empty"] = -1] = "empty";
  QuestionType[QuestionType["singleChoice"] = 1] = "singleChoice";
  QuestionType[QuestionType["multipleChoice"] = 2] = "multipleChoice";
  QuestionType[QuestionType["fillIn"] = 3] = "fillIn";
  QuestionType[QuestionType["cascade"] = 4] = "cascade";
  QuestionType[QuestionType["uploadAddon"] = 6] = "uploadAddon";
  QuestionType[QuestionType["sort"] = 21] = "sort";
  QuestionType[QuestionType["proportion"] = 22] = "proportion";
  QuestionType[QuestionType["phoneNumber"] = 7] = "phoneNumber";
  QuestionType[QuestionType["fillInMulti"] = 11] = "fillInMulti";
  QuestionType[QuestionType["fillInRange"] = 12] = "fillInRange";
  QuestionType[QuestionType["fillInTable"] = 23] = "fillInTable";
  QuestionType[QuestionType["dateTime"] = 13] = "dateTime";
  QuestionType[QuestionType["addressInput"] = 14] = "addressInput";
  QuestionType[QuestionType["singleChoicePicker"] = 9] = "singleChoicePicker";
  QuestionType[QuestionType["multipleChoicePicker"] = 10] = "multipleChoicePicker";
  QuestionType[QuestionType["patientName"] = 25] = "patientName";
  QuestionType[QuestionType["age"] = 26] = "age";
  QuestionType[QuestionType["sex"] = 27] = "sex";
  QuestionType[QuestionType["diagnosisTime"] = 28] = "diagnosisTime";
  QuestionType[QuestionType["diagnosis"] = 29] = "diagnosis";
  QuestionType[QuestionType["onlineBooking"] = 30] = "onlineBooking";
  QuestionType[QuestionType["department"] = 31] = "department";
})(QuestionType || (QuestionType = {}));
export const questionData = [{
  name: "选择组件",
  key: "selectArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        openPoint: false,
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        selectRangeMin: "",
        selectRangeMax: "",
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "下拉单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoicePicker,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        openPoint: false
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "下拉多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoicePicker,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true
      }
    }
  }]
}, {
  name: "填空组件",
  key: "inputArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "简答题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "区间填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInRange,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        numberValidate: true,
        inputForm: "NUMBER",
        content1: "",
        content2: "",
        inputNumberMin1: undefined,
        inputNumberMax1: undefined,
        inputNumberPrecision1: 0,
        inputNumberMin2: undefined,
        inputNumberMax2: undefined,
        inputNumberPrecision2: 0
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "横向填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInMulti,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        inputList: [{
          inputForm: "NONE",
          content: "",
          title: "",
          inputNumberMin: undefined,
          inputNumberMax: undefined,
          inputNumberPrecision: 0,
          inputMin: undefined,
          inputMax: undefined
        }, {
          inputForm: "NONE",
          content: "",
          title: "",
          inputNumberMin: undefined,
          inputNumberMax: undefined,
          inputNumberPrecision: 0,
          inputMin: undefined,
          inputMax: undefined
        }]
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "矩阵填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInTable,
    icon: "",
    data: {
      title: "",
      itemScore: 0,
      required: 1,
      optionsList: [],
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        rowList: [{
          value: "",
          content: "行标题1",
          rightOption: false,
          otherInput: false,
          inputMax: undefined,
          subTitle: ""
        }],
        columnList: [{
          value: "",
          content: "列标题1",
          rightOption: false,
          otherInput: false,
          inputMax: undefined,
          subTitle: ""
        }],
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        isCountTotalNumber: false,
        crossCellText: "",
        totalFormulaType: false,
        totalFormula: "",
        isResultTypeEnabled: false,
        resultTypeTitle: "",
        resultTypeRuleList: [],
        defaultResultType: "暂无对应类型"
      }
    }
  }]
}, {
  name: "高级组件",
  key: "advanceArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "排序题",
    title: "请对以下选项排序",
    componentName: QuestionType.sort,
    icon: "",
    data: {
      required: 1,
      title: "",
      optionContentType: "TEXT",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        selectRangeMin: "",
        selectRangeMax: ""
      },
      optionsList: [{
        value: "1",
        content: "选项1",
        rightOption: true,
        otherInput: false
      }, {
        value: "2",
        content: "选项2",
        rightOption: false,
        otherInput: false
      }]
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "比重题",
    title: "请填写以下内容",
    componentName: QuestionType.proportion,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      title: "",
      jsonConfig: {
        showIndex: true,
        total: 100
      },
      optionsList: [{
        value: "1",
        content: "选项1",
        rightOption: true,
        otherInput: false
      }, {
        value: "2",
        content: "选项2",
        rightOption: false,
        otherInput: false
      }]
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "上传附件",
    title: "请上传附件",
    componentName: QuestionType.uploadAddon,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        picTypes: [],
        fileTypes: [],
        videoTypes: [],
        showIndex: true,
        isIndeterminateFile: false,
        isIndeterminatePic: false,
        isIndeterminateVideo: false
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "日期时间",
    title: "请选择日期时间",
    componentName: QuestionType.dateTime,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        dateType: "date",
        minDateType: "",
        maxDateType: "",
        minRequirementDate: "",
        maxRequirementDate: ""
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "地址",
    title: "请选择地址",
    componentName: QuestionType.addressInput,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        addressType: "p_c_a"
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "预约",
    title: "预约",
    componentName: QuestionType.onlineBooking,
    icon: "",
    data: {
      required: 1,
      // uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        appointmentTimeMultiple: false,
        subTitle: "",
        showIndex: true,
        appointmentName: "",
        imgUrl: "",
        appointmentMethod: "APPOINTMENT_METHOD_PERIOD",
        weeklyAppointmentDate: [],
        dailyStartAndEndTime: ["09:00", "18:00"],
        hourlyDuration: undefined,
        intervalTime: undefined,
        quota: undefined,
        appointmentDateRangeType: "UNLIMITED",
        appointmentDateRange: [],
        notAppointmentDateRange: []
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "科室",
    title: "科室",
    componentName: QuestionType.department,
    icon: "",
    data: {
      required: 1,
      // uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true
      }
    }
  }]
}, {
  name: "其他组件",
  key: "decoArray",
  questionItem: [{
    type: IQuestionComonentType.Decoration,
    name: "图片",
    title: "请上传图片",
    componentName: DecorationType.picture,
    icon: "",
    data: {
      url: "",
      number: 0
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "描述说明",
    title: "请填写描述说明",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: ""
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分割线",
    title: "",
    componentName: DecorationType.cutOffLine,
    icon: "",
    data: {
      jsonConfig: {
        lineStyleType: "1",
        text: ""
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "计算字段",
    title: "计算结果是",
    componentName: DecorationType.calculator,
    icon: "",
    data: {
      required: 0,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: false,
        percentMode: false,
        calculatorList: [],
        scoreVerificationEnabled: false,
        scoreVerificationList: []
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分页",
    title: "",
    componentName: DecorationType.pageGap,
    icon: "",
    data: {
      text: ""
    }
  }]
}, {
  name: "唯一性组件",
  key: "uniqueArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "名称题",
    title: "请填写患者姓名首字母缩写",
    componentName: QuestionType.patientName,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "年龄题",
    title: "请填写患者年龄",
    componentName: QuestionType.age,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NUMBER",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "性别题",
    title: "请选择患者性别",
    componentName: QuestionType.sex,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "male",
        content: "男",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }, {
        value: "female",
        content: "女",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        openPoint: false
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "确诊时间题",
    title: "请填写患者确诊时间",
    componentName: QuestionType.diagnosisTime,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        dateType: "date",
        minDateType: "",
        maxDateType: "",
        minRequirementDate: "",
        maxRequirementDate: ""
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "诊断题",
    title: "请选择诊断",
    componentName: QuestionType.diagnosis,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "选项1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "选项2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        selectRangeMin: "",
        selectRangeMax: "",
        fillInMin: undefined,
        fillInMax: undefined
      }
    }
  }]
}];
export const questionDataForQAE = [{
  name: "选择组件",
  key: "selectArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        openPoint: false,
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        selectRangeMin: "",
        selectRangeMax: "",
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "下拉单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoicePicker,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        openPoint: false
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "下拉多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoicePicker,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true
      }
    }
  }]
}, {
  name: "填空组件",
  key: "inputArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "简答题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "区间填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInRange,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        numberValidate: true,
        inputForm: "NUMBER",
        content1: "",
        content2: "",
        inputNumberMin1: undefined,
        inputNumberMax1: undefined,
        inputNumberPrecision1: 0,
        inputNumberMin2: undefined,
        inputNumberMax2: undefined,
        inputNumberPrecision2: 0
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "横向填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInMulti,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        inputList: [{
          inputForm: "NONE",
          content: "",
          title: "",
          inputNumberMin: undefined,
          inputNumberMax: undefined,
          inputNumberPrecision: 0,
          inputMin: undefined,
          inputMax: undefined
        }, {
          inputForm: "NONE",
          content: "",
          title: "",
          inputNumberMin: undefined,
          inputNumberMax: undefined,
          inputNumberPrecision: 0,
          inputMin: undefined,
          inputMax: undefined
        }]
      }
    }
  }]
}, {
  name: "高级组件",
  key: "advanceArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "排序题",
    title: "请对以下选项排序",
    componentName: QuestionType.sort,
    icon: "",
    data: {
      required: 1,
      title: "",
      optionContentType: "TEXT",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        selectRangeMin: "",
        selectRangeMax: ""
      },
      optionsList: [{
        value: "1",
        content: "选项1",
        rightOption: true,
        otherInput: false
      }, {
        value: "2",
        content: "选项2",
        rightOption: false,
        otherInput: false
      }]
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "比重题",
    title: "请填写以下内容",
    componentName: QuestionType.proportion,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      title: "",
      jsonConfig: {
        showIndex: true,
        total: 100
      },
      optionsList: [{
        value: "1",
        content: "选项1",
        rightOption: true,
        otherInput: false
      }, {
        value: "2",
        content: "选项2",
        rightOption: false,
        otherInput: false
      }]
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "上传附件",
    title: "请上传附件",
    componentName: QuestionType.uploadAddon,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        picTypes: [],
        fileTypes: [],
        videoTypes: [],
        showIndex: true,
        isIndeterminateFile: false,
        isIndeterminatePic: false,
        isIndeterminateVideo: false
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "日期时间",
    title: "请选择日期时间",
    componentName: QuestionType.dateTime,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        dateType: "date",
        minDateType: "",
        maxDateType: "",
        minRequirementDate: "",
        maxRequirementDate: ""
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "地址",
    title: "请选择地址",
    componentName: QuestionType.addressInput,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        addressType: "p_c_a"
      }
    }
  },
  // {
  //   type: IQuestionComonentType.Question,
  //   name: "预约",
  //   title: "预约",
  //   componentName: QuestionType.onlineBooking,
  //   icon: "",
  //   data: {
  //     required: 1,
  //     // uploadLimitCount: 1,
  //     title: "",
  //     jsonConfig: {
  //       appointmentTimeMultiple: false,
  //       subTitle: "",
  //       showIndex: true,
  //       appointmentName: "",
  //       imgUrl: "",
  //       appointmentMethod: "APPOINTMENT_METHOD_PERIOD",
  //       weeklyAppointmentDate: [],
  //       dailyStartAndEndTime: ["09:00", "18:00"],
  //       hourlyDuration: undefined,
  //       intervalTime: undefined,
  //       quota: undefined,
  //       appointmentDateRangeType: "UNLIMITED",
  //       appointmentDateRange: [],
  //       notAppointmentDateRange: [],
  //     },
  //   } as IOnlineBooking,
  // },
  {
    type: IQuestionComonentType.Question,
    name: "科室",
    title: "科室",
    componentName: QuestionType.department,
    icon: "",
    data: {
      required: 1,
      // uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true
      }
    }
  }]
}, {
  name: "其他组件",
  key: "decoArray",
  questionItem: [{
    type: IQuestionComonentType.Decoration,
    name: "图片",
    title: "请上传图片",
    componentName: DecorationType.picture,
    icon: "",
    data: {
      url: "",
      number: 0
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "描述说明",
    title: "请填写描述说明",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: ""
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分割线",
    title: "",
    componentName: DecorationType.cutOffLine,
    icon: "",
    data: {
      jsonConfig: {
        lineStyleType: "1",
        text: ""
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "计算字段",
    title: "计算结果是",
    componentName: DecorationType.calculator,
    icon: "",
    data: {
      required: 0,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: false,
        percentMode: false,
        calculatorList: [],
        scoreVerificationEnabled: false,
        scoreVerificationList: []
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分页",
    title: "",
    componentName: DecorationType.pageGap,
    icon: "",
    data: {
      text: ""
    }
  }]
}];
export const questionDataForReviews = [{
  name: "填空组件",
  key: "inputArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "简答题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "矩阵填空",
    title: "请填写本项内容",
    componentName: QuestionType.fillInTable,
    icon: "",
    data: {
      title: "",
      itemScore: 0,
      required: 1,
      optionsList: [],
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        rowList: [{
          value: "",
          content: "行标题1",
          rightOption: false,
          otherInput: false,
          inputMax: undefined,
          subTitle: ""
        }],
        columnList: [{
          value: "",
          content: "列标题1",
          rightOption: false,
          otherInput: false,
          inputMax: null,
          subTitle: ""
        }],
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        isCountTotalNumber: false,
        crossCellText: "",
        totalFormulaType: false,
        totalFormula: "",
        isResultTypeEnabled: false,
        resultTypeTitle: "",
        resultTypeRuleList: [],
        defaultResultType: "暂无对应类型"
      }
    }
  }]
}];
export const testData = [{
  name: "选择组件",
  key: "selectArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "单选题",
    title: "请选择以下选项",
    componentName: QuestionType.singleChoice,
    icon: "",
    data: {
      required: 1,
      itemScore: 0,
      optionContentType: "TEXT",
      scoreRule: "SAME",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        rightOption: true,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined,
          itemScore: 0
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        rightOption: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined,
          itemScore: 0
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        openPoint: false,
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "多选题",
    title: "请选择以下选项",
    componentName: QuestionType.multipleChoice,
    icon: "",
    data: {
      required: 1,
      optionContentType: "TEXT",
      itemScore: 0,
      scoreRule: "SAME",
      optionsList: [{
        value: "1",
        content: "选项1",
        otherInput: false,
        rightOption: true,
        jsonConfig: {
          exclusive: false,
          itemScore: 0
        }
      }, {
        value: "2",
        content: "选项2",
        otherInput: false,
        rightOption: false,
        jsonConfig: {
          exclusive: false,
          itemScore: 0
        }
      }],
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined,
        selectRangeMin: "",
        selectRangeMax: "",
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: undefined,
        secondOtherInputNumberMax: undefined,
        secondOtherInputNumberPrecision: 0,
        secondOtherInputMin: undefined,
        secondOtherInputMax: undefined
      }
    }
  }]
}, {
  name: "其他组件",
  key: "decoArray",
  questionItem: [{
    type: IQuestionComonentType.Decoration,
    name: "图片",
    title: "请上传图片",
    componentName: DecorationType.picture,
    icon: "",
    data: {
      url: "",
      number: 0
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "描述说明",
    title: "请填写描述说明",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: ""
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分割线",
    title: "",
    componentName: DecorationType.cutOffLine,
    icon: "",
    data: {
      jsonConfig: {
        lineStyleType: "1",
        text: ""
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "分页",
    title: "",
    componentName: DecorationType.pageGap,
    icon: "",
    data: {
      text: ""
    }
  }]
}];
export const decorationData = [{
  type: IQuestionComonentType.Decoration,
  name: "图片",
  title: "请上传图片",
  componentName: DecorationType.picture,
  icon: "",
  data: {
    url: "",
    number: 0
  }
}, {
  type: IQuestionComonentType.Decoration,
  name: "文字",
  title: "请填写文字",
  componentName: DecorationType.text,
  icon: "",
  data: {
    text: ""
  }
}];
export const literatureData = [{
  name: "文献信息组件",
  key: "inputArray",
  questionItem: [{
    type: IQuestionComonentType.Question,
    name: "简答题",
    title: "请填写本项内容",
    componentName: QuestionType.fillIn,
    icon: "",
    data: {
      title: "",
      required: 1,
      content: "",
      jsonConfig: {
        subTitle: "",
        default: "",
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: undefined,
        inputNumberMax: undefined,
        inputNumberPrecision: 0,
        inputMin: undefined,
        inputMax: undefined
      }
    }
  }, {
    type: IQuestionComonentType.Question,
    name: "日期时间",
    title: "请选择日期时间",
    componentName: QuestionType.dateTime,
    icon: "",
    data: {
      required: 1,
      uploadLimitCount: 1,
      title: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        dateType: "date",
        minDateType: "",
        maxDateType: "",
        minRequirementDate: "",
        maxRequirementDate: ""
      }
    }
  }, {
    type: IQuestionComonentType.Decoration,
    name: "描述说明",
    title: "请填写描述说明",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: ""
    }
  }]
}];